import { Box, BoxProps } from '@mui/material'
import { FC } from 'react'
import { useTheme, styled } from '@mui/material/styles'
import { FastfoodIcon } from 'components/images'

export const ItemImageBox = styled(Box)((props) => {
  const theme = props.theme
  return {
    alignSelf: 'stretch',
    borderRadius: theme.spacing(1.5),
    border: `1px solid ${theme.palette.grey[100]}`,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: 100,
    minWidth: 100,
    [theme.breakpoints.down('sm')]: {
      width: 80,
      minWidth: 80,
    },
  }
})

export const ItemImage: FC<BoxProps & { src?: string }> = (props) => {
  const theme = useTheme()
  const { src, sx, ...rest } = props
  return src ? (
    <ItemImageBox
      {...rest}
      sx={{
        ...sx,
        backgroundImage: `url(${src})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPositionX: 'center',
        backgroundPositionY: 'center',
      }}
    />
  ) : (
    <ItemImageBox
      sx={{
        ...sx,
        '& svg': {
          marginY: 'auto',
          color: theme.palette.primary.main,
          width: 80,
          height: 'fit-content',
        },
        [theme.breakpoints.down('sm')]: {
          '& svg': {
            width: 64,
          }
        }
      }}
      {...rest}
    >
      <FastfoodIcon />
    </ItemImageBox>
  )
}
